export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';

export default {
  SHOW_MESSAGE,
  HIDE_MESSAGE,
};
